import React, { useEffect, useState, useRef } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import "../styles/DietPlanManagement.css";
import { FaRegFilePdf } from "react-icons/fa";
import { useParams } from "react-router-dom";
import API_URL from "../config";
import axios from "axios";
import { useAdmin } from "../contexts/AdminContext";

const EditExercise = () => {
  const { admin } = useAdmin();
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/${id}/${admin.branch}`);
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    fetchUser();
  }, [id]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSave = async () => {
    if (!selectedFile) {
      alert("Please attach a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.patch(
        `${API_URL}/auth/${id}/${admin.branch}/exercisePlan`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Exercise plan updated successfully!");
      setSelectedFile(null);
      fetchUser();
    } catch (error) {
      alert("Failed to upload diet plan.");
    }
  };

  return (
    <div className="dietPlanManagementContainer">
      <div className="dietPlanManagementHeader">
        <div className="dietHeaderLeft">
          <FaRegCalendarAlt
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Edit Exercise</h2>
        </div>
      </div>
      <h3>Edit Exercise:</h3>
      <div className="userListInputMain" style={{ marginBottom: 20 }}>
        <div className="addUserListInputMain">
          <div className="addUserListInput">
            <label>Name</label>
            <input type="text" value={userData?.fullName} />
          </div>
          <div className="addUserListInput">
            <label>Phone no</label>
            <input type="text" value={userData?.phoneNo} />
          </div>
        </div>
        <div className="addUserListInputMain">
          <div className="addUserListInput">
            <label>Email ID</label>
            <input type="text" value={userData?.email} />
          </div>
          <div className="dietPlainDiv">
            <label>Membership Status</label>
            <div className="activeOrNot">
              <button>
                <div
                  style={{
                    backgroundColor:
                      new Date(userData?.renewalExpiryDate) < new Date() &&
                      "#ff0000",
                  }}
                ></div>
                {new Date(userData?.renewalExpiryDate) < new Date()
                  ? "Expired"
                  : `Active`}
              </button>
            </div>
          </div>
        </div>
        <div className="addUserListInputMain">
          <div className="dietPlainDiv">
            <label>View PDF </label>
            <div className="addAttachment" onClick={() => setShowPdf(!showPdf)}>
              <button>
                <FaRegFilePdf />
              </button>
            </div>
          </div>
          <div className="dietPlainDiv">
            <label>Attach PDF (Add diet plan chart)</label>
            <div className="addAttachment">
              <button onClick={handleButtonClick}>+</button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="application/pdf"
              />
            </div>
          </div>
        </div>
      </div>
      <button className="dietPlanSaveBtn" onClick={handleSave}>
        Save
      </button>

      {showPdf && userData?.exercisePlan && (
        <div className="pdfViewerContainer">
          <h3 style={{ textAlign: "center", margin: "10px 0" }}>
            Exercise Plan PDF
          </h3>
          <iframe
            src={`https://api.c3fitnesssciencegymgmail.com/files/${userData?.exercisePlan}`}
            width="100%"
            height="600px"
            style={{ border: "none" }}
            title="PDF Viewer"
          />
        </div>
      )}
    </div>
  );
};

export default EditExercise;
